import React from 'react';
import { useAppSelector } from 'core/store';
import { map } from 'lodash';
import {
  byUsersChartFields,
  colorsOfInsideSalesByUsersCharts,
} from '@dashboardWirelineInsideSalesDepartment/constants';
import DashboardBarChart from 'pages/Dashboard/shared/DashboardBarChart';
import { LabelPosition } from 'core/models/Recharts.models';

const ByUsersChart = () => {
  const byUsersData = useAppSelector((state) => state.dashboard.insideSalesUsers.data);
  const isLoading = useAppSelector((state) => state.dashboard.insideSalesUsers.isLoading);

  const formattedData = map(byUsersData, (item) => ({
    xDateKey: item.name,
    ...item.value,
  }));

  const barLabel = {
    label: { position: LabelPosition.TOP },
  };

  return (
    <DashboardBarChart
      data={formattedData}
      colors={colorsOfInsideSalesByUsersCharts}
      fields={byUsersChartFields}
      isLoading={isLoading}
      title="By Users"
      barLabel={barLabel}
      needInsideLabel
    />
  );
};

export default ByUsersChart;
